import { LRS_OBJECT_TYPES } from '@techchange/components';
import { messages } from '../../../i18n';

/**
 * Maps object types to internationalized labels.
 *
 * @param {Object} intl    The provider for internationalization.
 *
 * @returns {Object} Mapping of LRS object type names to set of internationalized labels.
 */
function getIntlObjectTypes(intl) {

	// TODO: should pass in all possible UI labels (e.g. past tense, etc.)
	return {
		[LRS_OBJECT_TYPES.CERTIFICATE]: {
			label: intl && intl.formatMessage(messages.TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_CERTIFICATE),
			value: LRS_OBJECT_TYPES.CERTIFICATE,
		},
		[LRS_OBJECT_TYPES.DISCUSSION_COMMENT]: {
			label: intl && intl.formatMessage(messages.TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_DISCUSSION_COMMENT),
			value: LRS_OBJECT_TYPES.DISCUSSION_COMMENT,
		},
		[LRS_OBJECT_TYPES.DISCUSSION_THREAD]: {
			label: intl && intl.formatMessage(messages.TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_DISCUSSION_THREAD),
			value: LRS_OBJECT_TYPES.DISCUSSION_THREAD,
		},
		[LRS_OBJECT_TYPES.DISCUSSION_TOPIC]: {
			label: intl && intl.formatMessage(messages.TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_DISCUSSION_TOPIC),
			value: LRS_OBJECT_TYPES.DISCUSSION_TOPIC,
		},
		[LRS_OBJECT_TYPES.EMBED]: {
			label: intl && intl.formatMessage(messages.TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_EMBED),
			value: LRS_OBJECT_TYPES.EMBED,
		},
		[LRS_OBJECT_TYPES.EVENT]: {
			label: intl && intl.formatMessage(messages.TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_EVENT),
			value: LRS_OBJECT_TYPES.EVENT,
		},
		[LRS_OBJECT_TYPES.FORM]: {
			label: intl && intl.formatMessage(messages.TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_FORM),
			value: LRS_OBJECT_TYPES.FORM,
		},
		[LRS_OBJECT_TYPES.FORM_ENTRY]: {
			label: intl && intl.formatMessage(messages.TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_FORM_ENTRY),
			value: LRS_OBJECT_TYPES.FORM_ENTRY,
		},
		[LRS_OBJECT_TYPES.IMAGE]: {
			label: intl && intl.formatMessage(messages.TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_IMAGE),
			value: LRS_OBJECT_TYPES.IMAGE,
		},
		[LRS_OBJECT_TYPES.LINK]: {
			label: intl && intl.formatMessage(messages.TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_LINK),
			value: LRS_OBJECT_TYPES.LINK,
		},
		[LRS_OBJECT_TYPES.MIRO]: {
			label: intl && intl.formatMessage(messages.TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_MIRO),
			value: LRS_OBJECT_TYPES.MIRO,
		},
		[LRS_OBJECT_TYPES.PAGE]: {
			label: intl && intl.formatMessage(messages.TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_PAGE),
			value: LRS_OBJECT_TYPES.PAGE,
		},
		[LRS_OBJECT_TYPES.POINT]: {
			label: intl && intl.formatMessage(messages.TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_POINTS),
			value: LRS_OBJECT_TYPES.POINT,
		},
		[LRS_OBJECT_TYPES.POLL]: {
			label: intl && intl.formatMessage(messages.TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_POLL),
			value: LRS_OBJECT_TYPES.POLL,
		},
		[LRS_OBJECT_TYPES.QUIZ]: {
			label: intl && intl.formatMessage(messages.TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_QUIZ),
			value: LRS_OBJECT_TYPES.QUIZ,
		},
		[LRS_OBJECT_TYPES.SESSION]: {
			label: intl && intl.formatMessage(messages.TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_SESSION),
			value: LRS_OBJECT_TYPES.SESSION,
		},
		[LRS_OBJECT_TYPES.SLIDE]: {
			label: intl && intl.formatMessage(messages.TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_SLIDE),
			value: LRS_OBJECT_TYPES.SLIDE,
		},
		[LRS_OBJECT_TYPES.VIDEO]: {
			label: intl && intl.formatMessage(messages.TC_COMPONENTS_GENERAL_TEXT_LRS_OBJECT_TYPE_VIDEO),
			value: LRS_OBJECT_TYPES.VIDEO,
		},
	};

}

/**
 * Maps object types to corresponding metadata.
 *
 * @param {Object} intl    The provider for internationalization.
 * @param {Array} types    Optional list of object types to return in the map.
 *                         If empty, will return all object types.
 *
 * @returns {Object} Mapping of object types to corresponding metadata.
 */
export default function getObjectTypeMap(intl, types = []) {

	const objectTypesMap = getIntlObjectTypes(intl);

	objectTypesMap[LRS_OBJECT_TYPES.DISCUSSION_COMMENT].requiresParent = true;
	objectTypesMap[LRS_OBJECT_TYPES.DISCUSSION_THREAD].requiresParent = true;
	objectTypesMap[LRS_OBJECT_TYPES.FORM_ENTRY].requiresParent = true;

	// Return all object types if none specified
	if (types.length === 0) {
		return Object.assign({}, objectTypesMap);
	}

	// Build custom options map if types are specified
	const result = {};

	types.forEach((type) => {

		result[type] = objectTypesMap[type];

	});

	return result;

}
